import { useTranslation } from 'react-i18next';
import GoldButton from '../ui/GoldButton';
import ImageWithFallback from '../ui/ImageWithFallback';

function HeroFallback() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 1600 900"
      preserveAspectRatio="xMidYMid slice"
      className="absolute inset-0 w-full h-full"
    >
      <defs>
        <linearGradient id="h-sky" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#EAE2D2" />
          <stop offset="55%" stopColor="#FBF8F3" />
          <stop offset="100%" stopColor="#F2EAD9" />
        </linearGradient>
        <linearGradient id="h-lake" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#3B7BA8" />
          <stop offset="35%" stopColor="#1F4E79" />
          <stop offset="100%" stopColor="#0E2F4F" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="1600" height="600" fill="url(#h-sky)" />
      <rect x="0" y="540" width="1600" height="220" fill="url(#h-lake)" />
      <rect x="0" y="720" width="1600" height="180" fill="#C8B58F" />
    </svg>
  );
}

export default function Hero() {
  const { t } = useTranslation();
  return (
    <section
      id="home"
      className="relative isolate overflow-hidden min-h-[88vh] flex items-center justify-center"
      aria-labelledby="hero-title"
    >
      <div className="absolute inset-0 -z-10">
        <ImageWithFallback
          src="/images/hero-tahoe-couple.jpg"
          alt={t('hero.altImage')}
          loading="eager"
          keepFallback
          fallback={<HeroFallback />}
          className="hidden sm:block absolute inset-0 w-full h-full object-cover object-center"
        />
        <ImageWithFallback
          src="/images/hero_image.png"
          alt={t('hero.altImage')}
          loading="eager"
          keepFallback
          fallback={<HeroFallback />}
          className="block sm:hidden absolute inset-0 w-full h-full object-cover object-center"
        />
      </div>

      <div
        aria-hidden="true"
        className="absolute inset-0 -z-10 bg-gradient-to-b from-brand-paper/55 via-brand-paper/10 to-brand-paper/30 pointer-events-none"
      />

      <div className="relative z-10 px-6 text-center max-w-3xl mx-auto pt-16 sm:pt-20 pb-24 sm:pb-28 mb-[55vh] sm:mb-[50vh] md:mb-[45vh]">

        <h1 id="hero-title" className="mt-4 flex justify-center">
          <img 
            src="/images/logo-transparent.png" 
            alt={t('hero.names')} 
            className="h-48 sm:h-64 md:h-80 w-auto object-contain"
          />
        </h1>
        <div className="mt-4 sm:-mt-2 md:-mt-8 flex flex-col items-center justify-center gap-0">
          <p className="font-serif text-[0.7rem] sm:text-[0.75rem] tracking-[0.35em] uppercase text-brand-ink/80 z-10">
            {t('hero.weekday')}
          </p>
          <p className="font-serif text-6xl sm:text-7xl text-brand-gold leading-[0.75] my-0 sm:-my-1 md:-my-2">
            18
          </p>
          <p className="font-serif text-[0.7rem] sm:text-[0.75rem] tracking-[0.35em] uppercase text-brand-ink/80 z-10">
            {t('hero.month')}
          </p>
          <p className="font-serif text-[0.7rem] sm:text-[0.75rem] tracking-[0.35em] uppercase text-brand-ink/80 z-10 mt-1 md:mt-0">
            2026
          </p>
        </div>
        <p className="mt-2 font-sans text-[0.7rem] tracking-widest uppercase text-brand-ink/80">
          {t('hero.venueShort')}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4 items-center justify-center">
          <GoldButton as="a" href="#confirm-attendance" variant="solid">
            {t('hero.ctaConfirm')}
          </GoldButton>
          <GoldButton as="a" href="#location" variant="solid">
            {t('hero.ctaLocation')}
          </GoldButton>
        </div>
      </div>
    </section>
  );
}
